import { render, staticRenderFns } from "./lecture-contents-list.vue?vue&type=template&id=65d7528c"
import script from "./lecture-contents-list.vue?vue&type=script&lang=js"
export * from "./lecture-contents-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports